













































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Button extends Vue {
  @Prop(Number) current: number;
  @Prop(Number) pages: number;

  get showedPages() {
    let pages = [];
    if (this.current !== 1)
      pages.push({ label: "start", page: 1, icon: "angle-double-left" });
    if (this.current - 2 > 0)
      pages.push({ label: this.current - 2, page: this.current - 2 });
    if (this.current - 1 > 0)
      pages.push({ label: this.current - 1, page: this.current - 1 });
    if (this.current > 0)
      pages.push({ label: this.current, page: this.current });
    if (this.current + 1 <= this.pages)
      pages.push({ label: this.current + 1, page: this.current + 1 });
    if (this.current + 2 <= this.pages)
      pages.push({ label: this.current + 2, page: this.current + 2 });
    if (this.current + 3 <= this.pages && pages.length < 5)
      pages.push({ label: this.current + 3, page: this.current + 3 });
    if (this.current + 4 <= this.pages && pages.length < 5)
      pages.push({ label: this.current + 4, page: this.current + 4 });
    if (this.current !== this.pages)
      pages.push({
        label: "end",
        page: this.pages,
        icon: "angle-double-right",
      });
    return pages;
  }
}
